import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialColumnModalState } from "./initializes";
import type { ColumnModal } from "./types";

const columnModalSlice = createSlice({
  name: "ColumnModal",
  initialState: initialColumnModalState,
  reducers: {
    setColumnModal: (state: ColumnModal, action: PayloadAction<boolean>) => {
      state.isColumnModal = action.payload;
    },
    setDataTypeModal: (state: ColumnModal, action: PayloadAction<boolean>) => {
      state.isDataTypeModal = action.payload;
    },
    setColumnDataType: (state: ColumnModal, action: PayloadAction<object>) => {
      state.columnDataType = action.payload;
    },
    setIsOpenColumnMemu: (state: ColumnModal, action: PayloadAction<boolean>) => {
      state.isOpenColumnMemu = action.payload;
    },
  },
});

export const { setColumnModal, setDataTypeModal, setColumnDataType, setIsOpenColumnMemu } = columnModalSlice.actions;

export default columnModalSlice.reducer;
